/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} End_Tolerance_SecondsInputs */



/**
* | output |
* | --- |
* | "End Tolerance (Seconds)" |
*
* @param {End_Tolerance_SecondsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const end_tolerance_seconds = /** @type {((inputs?: End_Tolerance_SecondsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<End_Tolerance_SecondsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tolérance de fin (secondes)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Endtoleranz (Sekunden)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tolleranza finale (secondi)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Допуск на конце (в секундах)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tolerancia final (segundos)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("最终公差（秒）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("終了許容値（秒）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अंतिम सहनशीलता (सेकंड)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tolerância final (segundos)")
	return /** @type {LocalizedString} */ ("End Tolerance (Seconds)")
});